import EmptyState from "../UI/EmptyState";
import { PhraseActions } from "./PhraseActions";

const FrasesTable = ({ frases }) => {
  // console.log(frases);
  if (!frases.length) return <EmptyState title="No hay frases" />;

  return (
    <div className="table-responsive scroll-sm">
      <table
        className="table bordered-table mb-0"
        style={{ minWidth: "800px" }}
      >
        <thead className="table-light">
          <tr>
            <th>Frase</th>
            <th>Plantel</th>
            <th>Estatus</th>
            <th>Acciones</th>
          </tr>
        </thead>

        <tbody>
          {frases.map((f) => (
            <tr key={f.id}>
              <td style={{ maxWidth: "600px" }}>{f.frase}</td>
              <td>{f.plantel_nombre}</td>
              <td>
                <span
                  className={`px-3 py-1 rounded-pill fw-medium text-sm ${
                    f.is_active
                      ? "bg-success-focus text-success-main"
                      : "bg-danger-focus text-danger-main"
                  }`}
                >
                  {f.is_active ? "Activo" : "Inactivo"}
                </span>
              </td>
              <td>
                <PhraseActions phrase={f} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FrasesTable;
